import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore
const Entities = () => import('@/entities/entities.vue');

// prettier-ignore
const Project = () => import('@/entities/project/project.vue');
// prettier-ignore
const ProjectUpdate = () => import('@/entities/project/project-update.vue');
// prettier-ignore
const ProjectDetails = () => import('@/entities/project/project-details.vue');
// prettier-ignore
const Language = () => import('@/entities/language/language.vue');
// prettier-ignore
const LanguageUpdate = () => import('@/entities/language/language-update.vue');
// prettier-ignore
const LanguageDetails = () => import('@/entities/language/language-details.vue');
// prettier-ignore
const Term = () => import('@/entities/term/term.vue');
// prettier-ignore
const TermUpdate = () => import('@/entities/term/term-update.vue');
// prettier-ignore
const TermDetails = () => import('@/entities/term/term-details.vue');
// prettier-ignore
const Translations = () => import('@/entities/translations/translations.vue');
// prettier-ignore
const TranslationsUpdate = () => import('@/entities/translations/translations-update.vue');
// prettier-ignore
const TranslationsDetails = () => import('@/entities/translations/translations-details.vue');
// prettier-ignore
const TranslationsHistory = () => import('@/entities/translations-history/translations-history.vue');
// prettier-ignore
const TranslationsHistoryUpdate = () => import('@/entities/translations-history/translations-history-update.vue');
// prettier-ignore
const TranslationsHistoryDetails = () => import('@/entities/translations-history/translations-history-details.vue');
// prettier-ignore
const Roles = () => import('@/entities/roles/roles.vue');
// prettier-ignore
const RolesUpdate = () => import('@/entities/roles/roles-update.vue');
// prettier-ignore
const RolesDetails = () => import('@/entities/roles/roles-details.vue');
// prettier-ignore
const TranslationUser = () => import('@/entities/translation-user/translation-user.vue');
// prettier-ignore
const TranslationUserUpdate = () => import('@/entities/translation-user/translation-user-update.vue');
// prettier-ignore
const TranslationUserDetails = () => import('@/entities/translation-user/translation-user-details.vue');
// prettier-ignore
const Tag = () => import('@/entities/tag/tag.vue');
// prettier-ignore
const TagUpdate = () => import('@/entities/tag/tag-update.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default {
  path: '/',
  component: Entities,
  children: [
    {
      path: 'project',
      name: 'Project',
      component: Project,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'project/new',
      name: 'ProjectCreate',
      component: ProjectUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'project/:projectId/edit',
      name: 'ProjectEdit',
      component: ProjectUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'project/:projectId/view',
      name: 'ProjectView',
      component: ProjectDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'language',
      name: 'Language',
      component: Language,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'language/new',
      name: 'LanguageCreate',
      component: LanguageUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'language/:languageId/edit',
      name: 'LanguageEdit',
      component: LanguageUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'language/:languageId/view',
      name: 'LanguageView',
      component: LanguageDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'term',
      name: 'Term',
      component: Term,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'term/new',
      name: 'TermCreate',
      component: TermUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'term/:termId/edit',
      name: 'TermEdit',
      component: TermUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'term/:termId/view',
      name: 'TermView',
      component: TermDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'tag',
      name: 'Tag',
      component: Tag,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'tag/new',
      name: 'TagCreate',
      component: TagUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'tag/:tagd/edit',
      name: 'TagEdit',
      component: TagUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'translations',
      name: 'Translations',
      component: Translations,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'translations/new',
      name: 'TranslationsCreate',
      component: TranslationsUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'translations/:translationsId/edit',
      name: 'TranslationsEdit',
      component: TranslationsUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'translations/:translationsId/view',
      name: 'TranslationsView',
      component: TranslationsDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'translations-history',
      name: 'TranslationsHistory',
      component: TranslationsHistory,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'translations-history/new',
      name: 'TranslationsHistoryCreate',
      component: TranslationsHistoryUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'translations-history/:translationsHistoryId/edit',
      name: 'TranslationsHistoryEdit',
      component: TranslationsHistoryUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'translations-history/:translationsHistoryId/view',
      name: 'TranslationsHistoryView',
      component: TranslationsHistoryDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'roles',
      name: 'Roles',
      component: Roles,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'roles/new',
      name: 'RolesCreate',
      component: RolesUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'roles/:rolesId/edit',
      name: 'RolesEdit',
      component: RolesUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'roles/:rolesId/view',
      name: 'RolesView',
      component: RolesDetails,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'translation-user',
      name: 'TranslationUser',
      component: TranslationUser,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'translation-user/new',
      name: 'TranslationUserCreate',
      component: TranslationUserUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'translation-user/:translationUserId/edit',
      name: 'TranslationUserEdit',
      component: TranslationUserUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'translation-user/:translationUserId/view',
      name: 'TranslationUserView',
      component: TranslationUserDetails,
      meta: { authorities: [Authority.ADMIN] },
    },
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  ],
};
